/**
 * Build-time configuration.
 *
 * These values are compiled into the bundle. They are configuration, not
 * secrets: protect them with API restrictions in Google Cloud Console, not by
 * hiding them.
 *
 * Note there is no API key. Reads as well as writes go through the signed-in
 * user's OAuth token, because the spreadsheet is private. An API key only ever
 * worked for publicly readable sheets.
 */
function required(name: string, value: string | undefined): string {
  if (!value) {
    throw new Error(
      `Missing ${name}. Copy .env.example to .env.local and fill it in.`
    );
  }
  return value;
}

export const config = {
  sheetId: required("VITE_SHEET_ID", import.meta.env.VITE_SHEET_ID),
  tasksTab: import.meta.env.VITE_SHEET_TAB || "TASKS",
  projectsTab: import.meta.env.VITE_PROJECTS_TAB || "Projects",
  clientId: required("VITE_GOOGLE_CLIENT_ID", import.meta.env.VITE_GOOGLE_CLIENT_ID),
  /** The dedicated calendar, created on first use. Never the primary one. */
  calendarName: import.meta.env.VITE_CALENDAR_NAME || "Task dashboard",
  /**
   * Both scopes are requested together. Adding the calendar scope invalidates
   * tokens issued before it, which is why the auth module's storage key is
   * versioned.
   */
  scope: [
    "https://www.googleapis.com/auth/spreadsheets",
    "https://www.googleapis.com/auth/calendar",
  ].join(" "),
} as const;
